module.exports = __webpack_public_path__ + "images/product-navigation/juulpods-d7df0932.svg";